export default __webpack_public_path__ + "static/media/entrega.1df51ccc.svg";